module.exports = __webpack_public_path__ + "static/media/energy.c3eaad53.svg";